import { render, staticRenderFns } from "./TaxRates.vue?vue&type=template&id=51fd3212&scoped=true&"
import script from "./TaxRates.vue?vue&type=script&lang=js&"
export * from "./TaxRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd3212",
  null
  
)

export default component.exports